// extracted by mini-css-extract-plugin
export var active = "_vr-1";
export var circle = "_vr-0";
export var completed = "_vr-2";
export var connector = "_vr-4";
export var connectorCompleted = "_vr-7";
export var connectorSpacer = "_vr-5";
export var iconStrokeOverride = "_vr-8";
export var labelContainer = "_vr-6";
export var pending = "_vr-3";